// This is only for a hack to get around an Android Chromium bug that crashes when
// an iframe inside a <dialog> navigates.
export default class KomojuDialogElement extends HTMLElement implements DialogElement {
  oldScroll: number = 0;

  connectedCallback() {
    this.style.display = "none";

    this.style.position = "absolute";
    this.style.left = "0";
    this.style.right = "0";
    this.style.top = "0";
    this.style.bottom = "0";
    this.style.width = "100%";
    this.style.height = "100dvh";
    this.style.zIndex = "1000";
    this.style.backgroundColor = "white";
  }

  close(_?: string | undefined): void {
    this.style.display = "none";
    window.scrollTo(0, this.oldScroll);
  }
  showModal(): void {
    this.oldScroll = window.scrollY || document.documentElement.scrollTop;
    this.style.display = "block";
    window.scrollTo(0, 0);
  }
}

